import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStories } from "../../api/storiesApi";

const initialState = {
  items: {},
  status: "",
  error: "",
};

export const fetchStories = createAsyncThunk(
  "story/fetchStories",
  async function ({ currentPage }, { rejectWithValue, getState }) {
    try {
      const filterGroups = getState().filters.items;
      const nodeAliasPath = getState().settings.nodeAliasPath;
      const lang = getState().settings.lang;
      const isKidsApp = getState().settings.isKidsApp;

      const payload = {
        filterGroups,
        nodeAliasPath,
      };
      const response = await getStories({
        payload,
        page: currentPage,
        lang,
        isKidsApp,
      });
      return response || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const storySlice = createSlice({
  name: "story",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStories.pending]: (state) => {
      state.status = "loading";
      state.error = null;
    },
    [fetchStories.fulfilled]: (state, action) => {
      state.status = "resolved";
      state.items = action.payload;
    },
    [fetchStories.rejected]: (state, action) => {
      state.status = "rejected";
      state.error = action.payload;
    },
  },
});

export const {} = storySlice.actions;

export default storySlice.reducer;
